"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionSelector = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Cascader = require("../Cascader");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _LocaleProvider = require("../LocaleProvider");
var _context = require("../ConfigProvider/context");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var defaultPopupProps = {
  show: false,
  title: '',
  buttons: []
};
var OptionSelector = function OptionSelector(props) {
  var _useContext = (0, _react.useContext)(_context.ConfigContext),
    translations = _useContext.translations;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var _useState = (0, _react.useState)(_objectSpread(_objectSpread({}, defaultPopupProps), {}, {
      onClose: function onClose() {
        return setPopupData(_objectSpread(_objectSpread({}, popupData), defaultPopupProps));
      }
    })),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    popupData = _useState2[0],
    setPopupData = _useState2[1];
  var className = props.className,
    content = props.content,
    options = props.options;
  var updatePopupData = function updatePopupData(data) {
    setPopupData(_objectSpread(_objectSpread({}, popupData), data));
  };
  var handleOptionClick = function handleOptionClick(option) {
    return function () {
      var _option$subOptions;
      ((_option$subOptions = option.subOptions) === null || _option$subOptions === void 0 ? void 0 : _option$subOptions.length) && updatePopupData({
        show: true,
        title: (translations === null || translations === void 0 ? void 0 : translations.btn_choose_issue) || trans(_constants.BTN_CHOOSE_ISSUE),
        buttons: option.subOptions.map(function (subOption) {
          return _objectSpread(_objectSpread({}, subOption), {}, {
            onClick: function onClick() {
              return updatePopupData(defaultPopupProps);
            }
          });
        })
      });
    };
  };
  var cascaderProps = {
    className: className,
    content: content,
    buttonGroup: {
      className: className,
      buttons: options.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          onClick: handleOptionClick(option)
        });
      })
    },
    popupProps: popupData
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('intent-selector'), className)
  }, /*#__PURE__*/_react.default.createElement(_Cascader.Cascader, cascaderProps));
};
exports.OptionSelector = OptionSelector;